import React, { useState, useEffect } from 'react';
import api from '../api';

export default function Backups() {
  const [backups, setBackups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const flash = (m) => { setMsg(m); setTimeout(() => setMsg(''), 3000); };

  const load = async () => {
    const r = await api.get('/backups');
    setBackups(r.data || []);
  };

  useEffect(() => { load(); }, []);

  const runBackup = async () => {
    setLoading(true);
    try {
      await api.post('/backups/run');
      load(); flash('Yedek alındı.');
    } catch(e) { flash('Yedek alınamadı.'); }
    finally { setLoading(false); }
  };

  const restore = async (filename) => {
    if (!window.confirm(`${filename} yedeği geri yüklensin mi? Mevcut veriler silinecek!`)) return;
    setLoading(true);
    try {
      await api.post('/backups/restore', { filename });
      flash('Yedek geri yüklendi.');
    } catch(e) { flash('Geri yükleme başarısız.'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{display:'flex',flexDirection:'column',gap:16}}>
      {msg && <div style={{padding:'8px 14px',borderRadius:'var(--radius)',background:'var(--green-bg)',color:'var(--green)',border:'1px solid var(--green-border)',fontSize:13}}>✓ {msg}</div>}
      <div className="card">
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:14}}>
          <div style={{fontSize:14,fontWeight:600}}>Yedekler</div>
          <button onClick={runBackup} disabled={loading} className="btn btn-dark">
            {loading ? 'Alınıyor...' : '+ Yedek Al'}
          </button>
        </div>
        {backups.length === 0 ? (
          <div style={{textAlign:'center',padding:'2rem',color:'var(--text3)',fontSize:13}}>Henüz yedek yok.</div>
        ) : (
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
            <thead><tr style={{borderBottom:'1px solid var(--border)'}}>
              {['Dosya','Tarih','Boyut',''].map(h=><th key={h} style={{padding:'6px 0',fontSize:10,color:'var(--text3)',fontWeight:500,textAlign:'left',textTransform:'uppercase'}}>{h}</th>)}
            </tr></thead>
            <tbody>
              {backups.map(b=>(
                <tr key={b.filename} style={{borderBottom:'1px solid var(--border2)'}}>
                  <td style={{padding:'10px 0',fontWeight:500,fontSize:12}}>{b.filename}</td>
                  <td style={{padding:'10px 0',color:'var(--text3)',fontSize:12}}>{b.date ? new Date(b.date).toLocaleDateString('tr-TR') : '—'}</td>
                  <td style={{padding:'10px 0',color:'var(--text3)',fontSize:12}}>{b.size ? (b.size/1024).toFixed(1)+' KB' : '—'}</td>
                  <td style={{padding:'10px 0',textAlign:'right'}}>
                    <button onClick={()=>restore(b.filename)} className="btn btn-ghost btn-sm">Geri Yükle</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
